// This file is auto-generated by scripts/generate-revision.js
// Do not edit manually - changes will be overwritten on next build

export const REVISION = '7c40a4dbc (dev)';
export const VERSION = '0.16.6';
